import { Injectable } from '@angular/core';
@Injectable()
export class UserService {
    public user: any = {
        email: '',
        first_name: '',
        last_name: '',
        username:'',
        preference: '',
        gender:'',
        overage: '',
        UID: ''
    }
}


// WEBPACK FOOTER //
// ./src/services/user.service.ts